import React from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'

import { fetchContract } from 'ducks/contract'
import { columns } from './data'
import { contractDetailPath } from 'routes'
import { 
  contractCreatePath,
  contractEditPath
} from 'routes'
import { 
  MainBodyContent, 
  CustomButton,
  SearchList2,
  TablePagination 
} from 'components'

import { ProcurementContainer, ProcurementBody } from '../styled'

const Contract = (props) => {
  const { listContract, loading, valueForm } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.fetchContract({page:1,size:pageSize,companyCode:localStorage.getItem('filterCompanyCode')|null})
  },[])

  return (
    <MainBodyContent
      headerTitle='Contract'
      accessoriesHeader={
        <div style={{display:'flex'}}>
          <CustomButton 
            onClick={() => props.history.push(contractCreatePath)}
            icon='plus'
            btnColor='gray'
            title='Create'/>
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList2 placeholder='Contract No., PO No., Title, Requester' pageSize={pageSize} fetchAPI={props.fetchContract} formSearchName='formSearchContract' filterDate filterStatus filterCompany useLocalCompanyCode isContractSearch/>
          <ReactTable
            columns={columns}
            data={Object.keys(listContract).length>0?listContract.data:[]}
            loading={loading}
            defaultPageSize={userPageSize}
            noDataText='No Contract data'
            previousText={<Icon name='arrow alternate circle left'/>}
            nextText={<Icon name='arrow alternate circle right'/>}
            className='contractList'

            PaginationComponent={TablePagination}
            pages={Object.keys(listContract).length>0?listContract.totalPage:0}
            currentPage={Object.keys(listContract).length>0?listContract.page:0}
            onPageChange={(pageIndex) => {
              props.fetchContract({...valueForm,page:pageIndex+1,size:pageSize, companyCode:localStorage.getItem('filterCompanyCode')||null})
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              setPageSize(pageSize)
              props.fetchContract({...valueForm,page:pageIndex+1,size:pageSize, companyCode:localStorage.getItem('filterCompanyCode')||null})
            }}

            getTdProps={(state, rowInfo, column) => {
              return {
                onClick: (e, handleOriginal) => {
                  if (rowInfo && column && column.Header !== '') {
                    if ([0, 5, 9].indexOf(rowInfo.original.status) >= 0) {
                      window.open(contractEditPath(rowInfo.original.id))
                    } else {
                      window.open(contractDetailPath(rowInfo.original.id))
                    }
                  }
                  if (handleOriginal) {
                    handleOriginal()
                  }
                }
              }
            }}
          />
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  listContract: state.contract.listContract.data,
  loading: state.contract.listContract.loading,
  valueForm: getFormValues('formSearchContract')(state)
})

const mapDispatchToProps = {
  fetchContract
}

const contForm = reduxForm({
  form: 'formSearchContract',
  enableReinitialize: true,
})(Contract)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)